import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { id: "TableAddedProducts" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "TableProductsColumnL" }
const _hoisted_4 = { class: "TableProductsColumnL" }
const _hoisted_5 = { class: "TableProductsColumnXL" }
const _hoisted_6 = { class: "TableProductsColumnM" }
const _hoisted_7 = { class: "CustomComponentActionsWrapper TableProductsColumnS ColumnAlignCenter" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "TableDropdownPanel"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingWrapper = _resolveComponent("LoadingWrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LoadingWrapper, {
      classes: [
				'CampaignEditorRow',
				'CampaignEditorSubtitle'
			],
      isLoading: _ctx.isLoading,
      tag: "h2"
    }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createTextVNode(" Added products ", -1 /* CACHED */)
      ]))]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["isLoading"]),
    _createVNode(_component_LoadingWrapper, {
      classes: [
				'CampaignEditorRow',
				'LargeLoadingContent',
				{ 'CampaignEditorText': !_ctx.isLoading && !_ctx.customProducts.length },
				{ 'NoCustomProductsMessage': !_ctx.isLoading && !_ctx.customProducts.length }
			],
      isLoading: _ctx.isLoading
    }, {
      default: _withCtx(() => [
        (_ctx.customProducts.length)
          ? (_openBlock(), _createElementBlock("table", _hoisted_2, [
              _createElementVNode("tbody", null, [
                _cache[1] || (_cache[1] = _createElementVNode("tr", null, [
                  _createElementVNode("th", { class: "TableProductsColumnL" }, " Delivery date "),
                  _createElementVNode("th", { class: "TableProductsColumnL" }, " Product type "),
                  _createElementVNode("th", { class: "TableProductsColumnXL" }, " Name "),
                  _createElementVNode("th", { class: "TableProductsColumnM" }, " Price "),
                  _createElementVNode("th", { class: "TableProductsColumnS ColumnAlignCenter" }, " Actions ")
                ], -1 /* CACHED */)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customProducts, (product, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: product.id,
                    class: _normalizeClass({ 'CustomBudgetModified': _ctx.idsOfModifiedCustomProducts.includes(product.id) })
                  }, [
                    _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.retrieveDateStringForCustomProduct(product)), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.retrieveTypeForCustomProduct(product)), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_5, _toDisplayString(product.name), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.retrievePriceForCustomProduct(product)), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_7, [
                      _createElementVNode("button", {
                        class: "NavigatorButton ButtonTableDropdownTrigger",
                        onClick: ($event: any) => (_ctx.onDropdownTriggerClicked(index))
                      }, null, 8 /* PROPS */, _hoisted_8),
                      (_ctx.selectedTableActionsDropdown === index)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("button", {
                              class: "ButtonTableDropdownItem",
                              onClick: ($event: any) => (_ctx.onEditClicked(product))
                            }, " Edit ", 8 /* PROPS */, _hoisted_10),
                            _createElementVNode("button", {
                              class: "ButtonTableDropdownItem",
                              onClick: ($event: any) => (_ctx.onDuplicateClicked(product))
                            }, " Duplicate ", 8 /* PROPS */, _hoisted_11),
                            _createElementVNode("button", {
                              class: "ButtonTableDropdownItem",
                              onClick: ($event: any) => (_ctx.onDeleteClicked(product))
                            }, " Delete ", 8 /* PROPS */, _hoisted_12)
                          ]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ], 2 /* CLASS */))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(" No custom products added ")
            ], 64 /* STABLE_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["classes", "isLoading"])
  ]))
}